// src/store/modules/sections.js
import axios from '@/plugins/axios';

const state = {
    sections: [], // 存储所有分栏
};

const getters = {
    /**
     * 获取所有分栏，按 sortRank 排序
     */
    allSections: (state) =>
        [...state.sections].sort((a, b) => a.sortRank - b.sortRank),

    /**
     * 根据 organization ID 获取分栏
     * @param {Function} state - Vuex state
     * @returns {Function} - 返回筛选函数
     */
    sectionsByOrganization: (state) => (orgId) =>
        state.sections
            .filter((section) => section.orgId === orgId)
            .sort((a, b) => a.sortRank - b.sortRank),
};

const actions = {
    /**
     * 获取所有分栏数据
     */
    async fetchSections({ commit }) {
        try {
            const response = await axios.get('/admin/getSections');
            console.log('API Response (fetchSections):', response);

            if (response && response.code === 200 && Array.isArray(response.data.sections)) {
                commit('setSections', response.data.sections);
            } else {
                console.error('API 返回的数据结构不正确:', response);
            }
        } catch (error) {
            console.error('获取分栏数据失败:', error);
            throw error;
        }
    },

    /**
     * 添加分栏
     * @param {Object} sectionData - 分栏数据
     */
    async addSection({ commit }, sectionData) {
        try {
            const response = await axios.post('/admin/sections/addSection', sectionData);
            console.log(sectionData)
            if (response.code === 200 && response.data) {
                commit('addSection', response.data);
            } else {
                console.error('添加分栏失败:', response.msg);
                throw new Error(response.msg || '添加分栏失败');
            }
        } catch (error) {
            console.error('添加分栏失败:', error);
            throw error;
        }
    },

    /**
     * 更新分栏
     * @param {Object} sectionData - 更新后的分栏数据
     */
    async updateSection({ commit }, sectionData) {
        try {

            console.log(sectionData)
            const response = await axios.put(`/admin/sections/updateSection/${sectionData.sectionId}`, sectionData);
            if (response.code === 200 && response.data) {
                commit('updateSection', response.data);
            } else {
                console.error('更新分栏失败:', response.msg);
                throw new Error(response.msg || '更新分栏失败');
            }
        } catch (error) {
            console.error('更新分栏失败:', error);
            throw error;
        }
    },

    /**
     * 删除分栏
     * @param commit
     * @param {Number} sectionId - 分栏 ID
     * @param orgId
     */
    async deleteSection({ commit }, payload) {
        try {
            const { sectionId, orgId } = payload;
            const response = await axios.post(`/admin/sections/deleteSection`, { sectionId, orgId });
            if (response.code === 200) {
                commit('deleteSection', sectionId);
            } else {
                console.error('删除分栏失败:', response.msg);
                throw new Error(response.msg || '删除分栏失败');
            }
        } catch (error) {
            console.error('删除分栏失败:', error);
            throw error;
        }
    },

    /**
     * 重排分栏顺序
     * @param {Object} payload - 包含 orgId 和 sections 的对象
     */
    async reorderSections({ commit }, { orgId, sections }) {
        try {
                console.log(orgId);
                console.log(sections);
                const response = await axios.post('/admin/sections/reorderSections', { orgId, sections });
            if (response.code === 200) {
                commit('setSectionsForOrganization', { orgId, sections });
            } else {
                console.error('重排分栏失败:', response.msg);
                throw new Error(response.msg || '重排分栏失败');
            }
        } catch (error) {
            console.error('重排分栏失败:', error);
            throw error;
        }
    },
};

const mutations = {
    /**
     * 设置所有分栏
     * @param {Object} state - Vuex state
     * @param {Array} sections - 分栏数组
     */
    setSections(state, sections) {
        state.sections = sections;
    },

    /**
     * 添加分栏
     * @param {Object} state - Vuex state
     * @param {Object} section - 新添加的分栏
     */
    addSection(state, section) {
        state.sections.push(section);
    },

    /**
     * 更新分栏
     * @param {Object} state - Vuex state
     * @param {Object} updatedSection - 更新后的分栏
     */
    updateSection(state, updatedSection) {
        const index = state.sections.findIndex((sec) => sec.sectionId === updatedSection.sectionId);
        if (index !== -1) {
            state.sections.splice(index, 1, updatedSection);
        } else {
            console.error('找不到对应的分栏，无法更新');
        }
    },

    /**
     * 删除分栏
     * @param {Object} state - Vuex state
     * @param {Number} sectionId - 分栏 ID
     */
    deleteSection(state, sectionId) {
        state.sections = state.sections.filter((sec) => sec.sectionId !== sectionId);
    },

    /**
     * 设置指定组织的分栏列表
     * @param {Object} state - Vuex state
     * @param {Object} payload - 包含 orgId 和 sections 的对象
     */
    setSectionsForOrganization(state, { orgId, sections }) {
        const orgSections = state.sections.filter((sec) => sec.orgId === orgId);
        // 移除当前组织的所有分栏
        state.sections = state.sections.filter((sec) => sec.orgId !== orgId);
        // 添加重新排序后的分栏
        state.sections = state.sections.concat(sections);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
